import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { ApiError, DataTablesService, MessageService, GuidService, ConfigService } from '../../../../../core';
import { ConfigEmpresa, isIdentificacaoRepresentanteNome } from '../../../../configuracoes/app/empresa';
import { RepresentanteFilter } from '../representante-filter';
import { RepresentanteFilterComponent } from '../representante-filter.component';
import { Representante } from '../../representante';
import { RepresentanteSearchHttpService, RepresentanteCrudHttpService } from '../../services';
import { RepresentanteSearchOrderBy } from '../../representante-search-orderby';
import { RepresentanteSearchRepresentante } from '../../representante-search';

@Component({
    selector: 'sgt-representante-filter-modal',
    templateUrl: './representante-filter-modal.component.html',
    styleUrls: ['./representante-filter-modal.component.less']
})
export class RepresentanteFilterModalComponent implements OnInit {
    configEmpresa: ConfigEmpresa;

    @Input() idModal: string;
    @Input() situacao: number; // Situação padrão
    @Output() selectEntity = new EventEmitter<Representante>();
    elModal: any;
    isSelectRegistered = false;

    entities: RepresentanteSearchRepresentante[];
    idDataTable: string;
    dataTable: any;
    filter = new RepresentanteFilter();
    @ViewChild('representanteFilter') representanteFilter: RepresentanteFilterComponent;
    @ViewChild('modalBody') modalBody: ElementRef;


    constructor(private el: ElementRef,
                private configService: ConfigService,
                private dataTablesService: DataTablesService,
                private messageService: MessageService,
                private representanteCrudHttpService: RepresentanteCrudHttpService,
                private representanteSearchHttpService: RepresentanteSearchHttpService,
                private guidService: GuidService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();

        this.create();
        this.idDataTable = this.guidService.generate();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    open() {
        this.representanteFilter.clear();
        // this.search();
        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Quando o filtro é alterado */
    onFilterChange() {
        this.search();
    }

    /** Ao limpar o filtro */
    onFilterCleaned() {
        this.search();
    }

    search() {
        // Se tiver a situaçõa padrão informada, sempre adicionamos ela no filtro
        if (this.situacao) {
            this.filter.situacoes = [this.situacao];
        }

        let orderBy: RepresentanteSearchOrderBy;
        if (isIdentificacaoRepresentanteNome(this.configEmpresa.identificacaoRepresentante)) {
            orderBy = RepresentanteSearchOrderBy.Nome;
        } else {
            orderBy = RepresentanteSearchOrderBy.NomeFantasia;
        }

        this.representanteSearchHttpService.search(this.filter, orderBy, 'asc', -1, -1)
        .subscribe(
            response => {
                this.entities = response?.representantes ?? [];
                this.afterSearch();
            },
            (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os representantes', error)
        );
    }

    private afterSearch() {
        this.representanteFilter.close();
        jQuery(this.modalBody.nativeElement).scrollTop(0);
        this.showTable();
    }

    showTable() {
        this.dataTablesService.showTable(jQuery(this.el.nativeElement).find(`#${this.idDataTable}`), this.dataTable, {
            pageLength: 12,
            searching: false,
            order: [[0, 'asc']],
            columnDefs: [
                {orderable: true, targets: 0},
                {
                    targets: 1,
                    createdCell: (td, cellData, rowData, row, col) => {
                        if (cellData) {
                            td.title = cellData;
                        }
                    }
                }
            ],
        }).then(dataTable => this.dataTable = dataTable);
    }

    /** Ao selecionar o representante emitimos o evento de seleção e fechamos o modal */
    onSelectEntity(searchRepresentante: RepresentanteSearchRepresentante) {
        if (!searchRepresentante) {
            this.close();
            return;
        }

        this.representanteCrudHttpService.find(searchRepresentante.id)
            .subscribe(
                entity => {
                    this.selectEntity.emit(entity);
                    this.close();
                },
                (error: ApiError) => this.messageService.error(error.message, 'Ocorreu um erro ao carregar o representante selcionado', error)
            );
    }

}
